import { create } from 'zustand';

import { StatusEnum, IState } from '../interfaces';

const initialState = {
  avaturnId: null,
  stateSnapshot: null,
  status: StatusEnum.Idle,
};

export const useChangeAvatarState = create<IState>((set) => ({
  ...initialState,
  setAvaturnId: (avaturnId) => set({ avaturnId }),
  setStateSnapshot: (stateSnapshot) => set({ stateSnapshot }),
  setStatus: (status) => set({ status }),
}));
